"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const StudyLesson = ({
  lesson,
  index,
  isLastLesson,
  children,
  onLessonClick,
  lessonBoxStyle = "bg-white",
  lessonTitleStyle = "font-semibold",
  lessonExplanationStyle = "",
  isReorderMode = false
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-start mb-4",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mr-4 flex flex-col items-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `w-12 h-12 ${lessonBoxStyle} border border-black flex items-center justify-center rounded-md`,
        onClick: onLessonClick,
        children: index + 1
      }), !isLastLesson && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "w-12 text-center border-t-black",
        children: "\u21E3"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${isReorderMode ? 'pr-10' : ''} flex-1`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: lessonTitleStyle,
          children: lesson.title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: lessonExplanationStyle,
          children: lesson.explanation
        })]
      }), children]
    })]
  }, index);
};
var _default = exports.default = StudyLesson;